import React, { useContext } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { Button } from '@mui/material';
import LegalDocumentInputFields from './LegalDocumentInputFields';
import LegalDocumentValidator from '../validators/LegalDocumentValidator';
import ApolloError from '@shared/components/ApolloError';
import { showErrorToast } from '@shared/services/toastService';
import { LegalDocumentsContext } from '../contexts/LegalDocumentsContext';

const REQUIRED_FIELDS_ERROR_MESSAGE = 'Please complete all required fields.';

const AddLegalDocumentForm = () => {
  const { organization, error, addLegalDocument } = useContext(LegalDocumentsContext);

  const form = useForm({
    resolver: joiResolver(LegalDocumentValidator.addSchema),
    defaultValues: {
      completedDate: null,
      orgUnitIds: []
    }
  });

  const { handleSubmit, reset } = form;

  const onSubmit = async newLegalDocument => {
    await addLegalDocument(newLegalDocument);
    reset();
  };

  const onError = () => {
    showErrorToast(REQUIRED_FIELDS_ERROR_MESSAGE);
  };

  if (error) {
    return <ApolloError />;
  }

  return (
    <div>
      <FormProvider {...form}>
        <form
          className='add-legal-documents-form'
          data-testid='add-legal-documents-form'
          onSubmit={handleSubmit(onSubmit, onError)}>
          <LegalDocumentInputFields organization={organization} />
          <div className='add-button'>
            <Button className='primary-button sm' type='submit'>
              Add
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default AddLegalDocumentForm;
